import { string, object } from "../../../../../util/yup";

export const buildInitialValues = ({ recruiterId }) => {
  return { reason: "", reportee_id: recruiterId };
};

export const validationSchema = object().shape({
  reason: string().required("Required").minWords(3).max(550, "Must be less than 550 characters"),
});
